import { render, staticRenderFns } from "./GenderFilter.vue?vue&type=template&id=4d3287e1&scoped=true&"
import script from "./GenderFilter.vue?vue&type=script&lang=js&"
export * from "./GenderFilter.vue?vue&type=script&lang=js&"
import style0 from "./GenderFilter.vue?vue&type=style&index=0&id=4d3287e1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3287e1",
  null
  
)

export default component.exports